import { createNetworkGroup, fetchCountries, fetchCountryGroupsByNetworkId, fetchTariffPlanTypes, updateSelectedCountries, } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import TwoWayToggleSmall from "@Components/Form/TwoWayToggleSmall";
import HoverTooltip from "@Components/HoverTooltip";
import InformationIcon from "@Components/Icons/Information";
import Loading from "@Components/Icons/Loading";
import { Tab, Tabs } from "@Components/Tab";
import { ERROR, ToastStatus } from "@Components/Toast";
import TruncatedText from "@Components/TruncatedText";
import { Box, tabsClasses, ToggleButton, Typography } from "@mui/material";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { CountryGroupType } from "@Shared/Entities/CountryGroups/CountryGroup/enums";
import { addNotification } from "@Store/Actions/Notifications";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styles from "./index.module.scss";
import { Delete, Form, InformUnchange } from "./popup";
import IncludeAllUnassigned from "./popup/IncludeAllUnassigned/IncludeAllUnassigned";
import ToggleSync from "./popup/ToggleSync/ToggleSync";
import Table from "./table/Table";
const styledToggleButton = {
    // 1. Unselected (Default) State
    backgroundColor: "#fff",
    color: "#888F97",
    border: "1px solid #CCD4DC !important",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "14px",
    lineHeight: "125%",
    "&:hover": {
        backgroundColor: "#F3FCF4", // Slightly darker hover
    },
    // 2. Selected State Override
    "&.Mui-selected": {
        backgroundColor: "#F3FCF4",
        color: "#00A555",
        "&:hover": {
            backgroundColor: "#F3FCF4", // Darker blue on hover when selected
        },
    },
};
class RoamingDays extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: "",
            nextTabValue: "",
            // dataType: {},
            rows: {},
            isDirtyForm: false,
            tabs: [],
            groupObj: {},
            showUnsavePopup: false,
            showFormPopup: false,
            showDeletePopup: false,
            selectedGroup: undefined,
            searchCountryValue: {},
            isFetching: false,
            isSaving: false,
            unblockListener: null,
            nextRoute: "",
            countryGroupType: CountryGroupType.Roaming,
            syncSetting: false,
            showToggleSyncPopup: false,
            showAssignAllUnassignedCountriesPopup: false,
            countries: [],
        };
    }
    setNavigationBlocker = (shouldBlock) => {
        if (this.state.unblockListener) {
            this.state.unblockListener();
        }
        if (shouldBlock) {
            const unblock = this.props.history.block((tx) => {
                this.setState({ showUnsavePopup: true, nextRoute: tx.pathname });
                return false;
            });
            this.setState({ unblockListener: unblock });
        }
        else {
            this.setState({ unblockListener: null });
        }
    };
    componentDidMount() {
        this.setState({ isFetching: true });
        fetchCountries()
            .then((countries) => {
            this.setState({ countries });
        })
            .finally(() => {
            this.setState({ isFetching: false });
        });
        this.setNavigationBlocker(this.state.isDirtyForm);
        this.onFetchCountryGroups({ skip: 0, take: 100 }).then(() => {
            if (this.state.tabValue) {
                this.onFetchNetwork(this.state.tabValue, this.state.countryGroupType, {
                    skip: 0,
                    take: 100,
                });
            }
        });
    }
    componentDidUpdate(previousProps, previousStates) {
        if (previousStates.isDirtyForm !== this.state.isDirtyForm) {
            this.setNavigationBlocker(this.state.isDirtyForm);
        }
    }
    componentWillUnmount() {
        if (this.state.isDirtyForm && this.state.unblockListener) {
            this.state.unblockListener();
        }
    }
    onFetchCountryGroups = async (params) => {
        this.setState({ isFetching: true });
        try {
            const response = await fetchTariffPlanTypes(params);
            if (this.state.tabValue === "") {
                const tab = response.items[0];
                this.setState({
                    tabs: response.items,
                    tabValue: tab?.id || response.items[0]?.id,
                    syncSetting: tab.sync,
                });
                return response;
            }
            const tab = response.items.find((tab) => tab.id === this.state.tabValue);
            if (tab) {
                this.setState({ tabs: response.items, syncSetting: tab.sync });
                return response;
            }
            this.setState({ tabs: response.items });
            return response;
        }
        catch (error) {
            this.props.notify({
                title: "Error",
                description: "Failed to fetch country groups",
                status: ERROR,
            });
            console.error("Failed to fetch country groups", error);
        }
        finally {
            this.setState({ isFetching: false });
        }
    };
    onFetchNetwork = async (id, countryGroupType, params) => {
        this.setState({ isFetching: true });
        try {
            const response = await fetchCountryGroupsByNetworkId(id, countryGroupType, params);
            if (response.items.length === 0) {
                this.createDefaultGroupColumns(id, countryGroupType);
                return;
            }
            this.setGroupObj(response.items);
            this.setState({
                rows: response.items.reduce((accumulator, currentItem) => {
                    const countryObject = currentItem.item.selectedCountries.reduce((countryAccumulator, country) => {
                        return {
                            ...countryAccumulator,
                            [country]: true,
                        };
                    }, {});
                    return {
                        ...accumulator,
                        [currentItem.item.id]: countryObject,
                    };
                }, {}),
                isDirtyForm: false,
                countryGroupType: countryGroupType,
            });
        }
        catch (error) {
            console.log("error", error);
            this.props.notify({
                title: "Error",
                description: "Failed to fetch network data",
                status: ERROR,
            });
            console.error("Failed to fetch network", error);
        }
        finally {
            this.setState({ isFetching: false });
        }
    };
    setGroupObj = (groupObject) => {
        const sortedGroups = groupObject.sort((a, b) => {
            const aCreatedAt = a.item.createdAt;
            const bCreatedAt = b.item.createdAt;
            return aCreatedAt.localeCompare(bCreatedAt);
        });
        const newGroupObject = sortedGroups.reduce((accumulator, currentItem, index) => {
            return {
                ...accumulator,
                [currentItem.item.id]: { ...currentItem.item, index },
            };
        }, {});
        this.setState({ groupObj: newGroupObject });
    };
    createDefaultGroupColumns = (networkId, countryGroupType) => {
        const defaultGroup = [
            {
                name: "Default Group",
                networkId: networkId,
                selectedCountries: [],
                type: countryGroupType,
            },
        ];
        createNetworkGroup(defaultGroup, this.state.syncSetting).then(() => {
            this.onFetchNetwork(networkId, CountryGroupType.Roaming, {
                skip: 0,
                take: 100,
            });
        });
    };
    handleChangeTab = (event, value) => {
        if (this.state.isDirtyForm) {
            this.setState({
                showUnsavePopup: true,
                nextTabValue: value,
            });
        }
        else {
            const tab = this.state.tabs.find((tab) => tab.id === value);
            if (!tab?.id) {
                this.props.notify({
                    title: "Error",
                    description: "Cannot find tab",
                    status: ERROR,
                });
                return;
            }
            this.setState({
                tabValue: value,
                countryGroupType: CountryGroupType.Roaming,
                syncSetting: tab.sync,
            });
            this.onFetchNetwork(tab.id, CountryGroupType.Roaming, {
                skip: 0,
                take: 100,
            });
        }
    };
    search = (event) => {
        this.setState({
            searchCountryValue: {
                ...this.state.searchCountryValue,
                [this.state.tabValue]: event.target.value,
            },
        });
    };
    getPreviousColumnId = (code, columnId) => {
        return Object.keys(this.state.rows).reduce((accumulator, currentGroupId) => {
            if (currentGroupId === columnId) {
                return accumulator;
            }
            const currentGroup = this.state.rows[currentGroupId];
            if (currentGroup[code]) {
                return currentGroupId;
            }
            return accumulator;
        }, null);
    };
    onCheck = (code, columnId, value) => {
        const previousColumnId = this.getPreviousColumnId(code, columnId);
        const newData = {
            ...this.state.rows,
            [columnId]: {
                ...this.state.rows[columnId],
                [code]: value,
            },
        };
        if (previousColumnId) {
            newData[previousColumnId] = {
                ...this.state.rows[previousColumnId],
                [code]: false,
            };
        }
        this.setState({
            rows: newData,
            isDirtyForm: true,
        });
    };
    onSave = async (tabId) => {
        if (!this.state.isDirtyForm || !this.state.tabValue) {
            return;
        }
        const newData = Object.keys(this.state.groupObj).reduce((accumulator, currentKey) => {
            const value = this.state.groupObj[currentKey];
            const selectedCountries = Object.keys(this.state.rows[value.id]).filter((key) => this.state.rows[value.id][key]);
            if (value.id === tabId) {
                return accumulator;
            }
            return [
                ...accumulator,
                {
                    ...value,
                    type: this.state.countryGroupType,
                    selectedCountries,
                },
            ];
        }, []);
        this.setState({ isSaving: true });
        try {
            const savedGroups = await updateSelectedCountries(this.state.tabValue, newData, this.state.syncSetting);
            this.setGroupObj(savedGroups.filter((savedGroup) => savedGroup.item.type === this.state.countryGroupType));
            this.setState({
                isDirtyForm: false,
            });
            this.props.notify({
                title: "Success",
                description: "Changes saved successfully.",
                status: ToastStatus.Success,
            });
        }
        catch (error) {
            console.log("error", error);
            this.props.notify({
                title: "Error",
                description: "Failed to save changes",
                status: ERROR,
            });
        }
        finally {
            this.setState({ isSaving: false });
        }
    };
    handleChangeTabWithoutSave = () => {
        if (this.state.nextRoute) {
            this.setNavigationBlocker(false);
            return this.props.history.push(this.state.nextRoute);
        }
        this.setState({
            isDirtyForm: false,
        });
        if (!this.state.nextTabValue) {
            this.props.notify({
                title: "Error",
                description: "Cannot find tab",
                status: ERROR,
            });
            return;
        }
        this.setState({
            tabValue: this.state.nextTabValue,
            nextTabValue: "",
            showUnsavePopup: false,
            isDirtyForm: false,
        });
        // when current subtab is unsaved before moving to other subtab
        if (this.state.nextTabValue === this.state.tabValue) {
            const type = this.state.countryGroupType === CountryGroupType.Roaming
                ? CountryGroupType.IDD
                : CountryGroupType.Roaming;
            this.onFetchNetwork(this.state.nextTabValue, type, {
                skip: 0,
                take: 100,
            });
            return;
        }
        this.onFetchNetwork(this.state.nextTabValue, CountryGroupType.Roaming, {
            skip: 0,
            take: 100,
        });
    };
    handleChangeSubtab = (_, newValue) => {
        if (newValue === null || newValue === this.state.countryGroupType) {
            return;
        }
        if (this.state.isDirtyForm) {
            this.setState({
                showUnsavePopup: true,
                nextTabValue: this.state.tabValue,
            });
        }
        else {
            this.onFetchNetwork(this.state.tabValue, newValue, {
                skip: 0,
                take: 100,
            });
        }
    };
    closeFormPopup = (refresh) => {
        this.setState({ showFormPopup: false, selectedGroup: undefined });
        if (refresh && this.state.tabValue) {
            this.onFetchNetwork(this.state.tabValue, this.state.countryGroupType, { skip: 0, take: 100 });
        }
    };
    closeDeletePopup = (refresh) => {
        this.setState({ showDeletePopup: false, selectedGroup: undefined });
        if (refresh && this.state.tabValue) {
            this.onFetchNetwork(this.state.tabValue, this.state.countryGroupType, { skip: 0, take: 100 });
        }
    };
    closeToggleSyncPopup = (refresh, isSync) => {
        this.setState({ showToggleSyncPopup: false, syncSetting: isSync });
        if (refresh && this.state.tabValue) {
            this.onFetchCountryGroups({ skip: 0, take: 100 });
            this.onFetchNetwork(this.state.tabValue, this.state.countryGroupType, { skip: 0, take: 100 });
        }
    };
    closeAssignAllUnassignedCountriesPopup = (refresh) => {
        this.setState({
            showAssignAllUnassignedCountriesPopup: false,
            selectedGroup: undefined,
        });
        if (refresh && this.state.tabValue) {
            this.onFetchNetwork(this.state.tabValue, this.state.countryGroupType, { skip: 0, take: 100 });
        }
    };
    render() {
        return (React.createElement(Card, { className: styles.card },
            this.state.tabValue && (React.createElement(Tabs, { variant: "scrollable", scrollButtons: "auto", primary: true, value: this.state.tabValue, onChange: this.handleChangeTab, sx: {
                    [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                    },
                } }, this.state.tabs.map((tab) => {
                return (React.createElement(Tab, { key: tab.id, primary: true, label: React.createElement(TruncatedText, { sx: { fontWeight: 600 } }, tab.name), value: tab.id }));
            }))),
            React.createElement(Box, { sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 24px 0 24px",
                } },
                React.createElement(Box, { sx: { width: "150px", flexShrink: 0 } },
                    React.createElement(ToggleButtonGroup, { color: "standard", value: this.state.countryGroupType, exclusive: true, onChange: this.handleChangeSubtab, size: "medium", "aria-label": "Platform" },
                        React.createElement(ToggleButton, { value: CountryGroupType.Roaming, sx: styledToggleButton }, "Roaming"),
                        React.createElement(ToggleButton, { value: CountryGroupType.IDD, sx: styledToggleButton }, "IDD"))),
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                    } },
                    React.createElement(Typography, null,
                        React.createElement(HoverTooltip, { icon: React.createElement(InformationIcon, { className: styles.iconTooltip }) },
                            "This will keep the country settings for Roaming and IDD the same. Any changes made in one will automatically update the other.",
                            " "),
                        "Synchronise Roaming and IDD settings"),
                    React.createElement(TwoWayToggleSmall, { value: this.state.syncSetting, toggle: () => {
                            this.setState({
                                showToggleSyncPopup: true,
                            });
                        }, onText: " ", offText: " ", name: "syncSetting" }))),
            React.createElement(Box, null,
                React.createElement("div", { role: "tabpanel", id: `simple-tabpanel-${this.state.tabValue}`, "aria-labelledby": `simple-tab-${this.state.tabValue}` },
                    React.createElement(Box, { className: styles.actionBar },
                        React.createElement("div", { className: styles.searchBar },
                            React.createElement("input", { key: this.state.tabValue, type: "text", placeholder: "Search by country", value: this.state.searchCountryValue[this.state.tabValue], onInput: this.search, className: `${styles.search}` }),
                            React.createElement(Button, { disabled: false, type: "button", click: () => this.setState({
                                    showFormPopup: true,
                                    selectedGroup: undefined,
                                }) }, "ADD NEW GROUP"),
                            React.createElement(Button, { disabled: !this.state.isDirtyForm, type: "button", className: `${this.state.isDirtyForm
                                    ? ""
                                    : styles.disabled}`, click: () => this.onSave(this.state.tabValue) }, this.state.isSaving ? (React.createElement(Loading, { size: "1rem" })) : ("SAVE")))),
                    React.createElement(Box, null,
                        React.createElement(Table, { countries: this.state.countries, groupColumns: Object.values(this.state.groupObj).sort((a, b) => {
                                return a.index - b.index;
                            }) || [], rows: this.state.rows, searchCountryValue: this.state.searchCountryValue[this.state.tabValue] || "", tabValue: this.state.tabValue, onCheckUnassignCountries: (group) => this.setState({
                                showAssignAllUnassignedCountriesPopup: true,
                                selectedGroup: group,
                            }), onCheck: this.onCheck, onEdit: (group) => this.setState({
                                selectedGroup: group,
                                showFormPopup: true,
                            }), onDelete: (group) => this.setState({
                                selectedGroup: group,
                                showDeletePopup: true,
                            }), countryGroupType: this.state.countryGroupType })))),
            React.createElement(InformUnchange, { open: this.state.showUnsavePopup, close: () => this.setState({ showUnsavePopup: false, nextRoute: "" }), onConfirm: this.handleChangeTabWithoutSave }),
            React.createElement(Form, { countries: this.state.countries, group: this.state.selectedGroup, networkId: this.state.tabValue, open: this.state.showFormPopup, close: this.closeFormPopup, notify: this.props.notify, allGroups: Object.keys(this.state.rows).reduce((allGroups, groupId) => {
                    allGroups.push({
                        ...this.state.groupObj[groupId],
                        selectedCountries: Object.keys(this.state.rows[groupId]).filter((countryCode) => this.state.rows[groupId][countryCode]),
                    });
                    return allGroups;
                }, []), countryGroupType: this.state.countryGroupType, isSync: this.state.syncSetting || false }),
            React.createElement(Delete, { open: this.state.showDeletePopup, close: this.closeDeletePopup, networkId: this.state.tabValue, groupId: this.state.selectedGroup?.id, groupName: this.state.selectedGroup?.name, notify: this.props.notify, countryGroupType: this.state.countryGroupType, isSync: this.state.syncSetting || false }),
            React.createElement(ToggleSync, { open: this.state.showToggleSyncPopup, close: this.closeToggleSyncPopup, networkId: this.state.tabValue, countryGroupType: this.state.countryGroupType, notify: this.props.notify, isSync: this.state.syncSetting || false }),
            React.createElement(IncludeAllUnassigned, { open: this.state.showAssignAllUnassignedCountriesPopup, close: this.closeAssignAllUnassignedCountriesPopup, networkId: this.state.tabValue, allGroups: Object.keys(this.state.rows).reduce((allGroups, groupId) => {
                    allGroups.push({
                        ...this.state.groupObj[groupId],
                        selectedCountries: Object.keys(this.state.rows[groupId]).filter((countryCode) => this.state.rows[groupId][countryCode]),
                    });
                    return allGroups;
                }, []), group: this.state.selectedGroup, countries: this.state.countries, notify: this.props.notify, countryGroupType: this.state.countryGroupType, isSync: this.state.syncSetting || false }),
            this.state.isFetching && (React.createElement("div", { className: styles.loadingOverlay },
                React.createElement(Loading, { size: "3rem" })))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        notify: (data) => addNotification(dispatch, data),
    };
};
const mapStateToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoamingDays));
